import React, { useState, useRef, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import "./AddBlog.css";
import { Editor } from "@tinymce/tinymce-react";
import Login from "../login/login";

function AddBlog() {
  const [editorContent, setEditorContent] = useState("");
  const[isAuthenticated,setIsAuthenticated]=useState(false)
  const [formData, setFormData] = useState({
    Tseed: 0,
    MetaTitle: "",
    MetaDescription: "",
    BlogType: null,
    Heading: "",
    Content: "",
    URL: "",
    Catagory: "",
    Tags: "",
    ImagePath: "",
  });
  const [blogImage, setBlogImage] = useState(null);

useEffect(()=>{
  const storedToken = JSON.parse(localStorage.getItem("token"));
  if(storedToken){
    setIsAuthenticated(true)
  }
},[])

  function isValidFileType(file) {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/svg"];
    return file && allowedTypes.includes(file.type);
  }

  const handleEditorChange = (value) => {
    setEditorContent(value);
    setFormData({ ...formData, Content: value });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  function handleChangeDoc(e) {
    const { name, value, files } = e.target;
    const file = files[0];
    if (isValidFileType(file)) {
      setBlogImage({ ImagePath: files[0] });
    } else {
      alert("Unsupported file type. Please upload a valid file.");
      e.target.value = null;
      return;
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      try {
        const response = await axios.post(
          `http://localhost:52712/api/CMB/AddBlog`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        InsertBlogImage();
      } catch (error) {
        console.error("Error posting data:", error);
      }
    }
  };

  const InsertBlogImage = async () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    const data = new FormData();
    data.append("URL", formData.URL);
    data.append("ImagePath", blogImage.ImagePath);

    try {
      const response = await axios.post(
        `http://localhost:52712/api/CMB/AddBlogImage`,
        data,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "multipart/form-data", // Ensure you're sending form data
          },
        }
      );
      alert(`Blog Added Successfully`);
      setFormData({
        MetaTitle: "",
        MetaDescription: "",
        BlogType: "",
        Heading: "",
        Content: "",
        URL: "",
        Catagory: "",
        Tags: "",
        ImagePath: "",
      });
      setEditorContent("");
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike"], // Formatting options
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"], // Add links and images
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];
if(isAuthenticated){
  return (
    <div className="container-fluid py-4 px-5">
      <h3 className="text-center">Add Blog</h3>
      <form>
        <div className="mb-3">
          <label htmlFor="MetaTitle" className="form-label">
            Meta Title
          </label>
          <input
            id="MetaTitle"
            name="MetaTitle"
            type="text"
            className="form-control"
            value={formData.MetaTitle}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="MetaDescription" className="form-label">
            Meta Description
          </label>
          <input
            id="MetaDescription"
            name="MetaDescription"
            type="text"
            className="form-control"
            value={formData.MetaDescription}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="BlogType" className="form-label">
            Blog Type
          </label>
          <input
            id="BlogType"
            name="BlogType"
            type="number"
            className="form-control"
            value={formData.BlogType}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="Heading" className="form-label">
            Heading
          </label>
          <input
            id="Heading"
            name="Heading"
            type="text"
            className="form-control"
            value={formData.Heading}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label
            htmlFor="Content"
            className="form-label text-2xl font-bold mb-4"
          >
            Content
          </label>
          {/* <ReactQuill
          onChange={handleEditorChange}
          modules={modules}
          formats={formats}
          value={editorContent}
          name="Content"
          theme="snow"
          placeholder="Write Description Here..."
        /> */}
          <Editor
            apiKey="u9p799ninz5ugta9esnnaddl48hi9utsuul5eqoqdymjddqn" // Get your free API key from TinyMCE
            value={formData.Content}
            onEditorChange={handleEditorChange}
            init={{
              plugins: "link image",
              toolbar: "bold italic underline | link image",
              placeholder: "Start typing...",
            }}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="URL" className="form-label">
            URL
          </label>
          <input
            id="URL"
            name="URL"
            type="text"
            className="form-control"
            value={formData.URL}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="Category" className="form-label">
            Category
          </label>
          <input
            id="Category"
            name="Catagory"
            type="text"
            className="form-control"
            value={formData.Catagory}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="Tags" className="form-label">
            Tags
          </label>
          <input
            id="Tags"
            name="Tags"
            type="text"
            className="form-control"
            value={formData.Tags}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="ImagePath" className="form-label">
            Thumbnail Image
          </label>
          <input
            id="ImagePath"
            name="ImagePath"
            type="file"
            className="form-control"
            onChange={handleChangeDoc}
          />
        </div>
        <div className="mb-3 text-end">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            Add Blog
          </button>
        </div>
      </form>
    </div>
  );
}
else{
  return <Login/>
}

}

export default AddBlog;
